<template>
  <!-- sqm - 色板管理 -->
  <h-list-page class="badMarket_style">
    <h-card
      :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')"
      width="100%"
      is-search
      :is-open="false"
      @change-method="changeMethod"
      footer
    >
      <h-area>
        <h-search :title="h_i18n('e7332e4013f0bea58f9f13846262f811')">
          <h-input v-model="searchData.colorBoardNo" clearable></h-input>
        </h-search>

        <h-search :title="h_i18n('7aadc5f1d43c0f7bf804117d00caa683')">
          <h-input v-model="searchData.colorCode" clearable></h-input>
        </h-search>

        <h-search :title="h_i18n('030f1b54354b7aa3f52055b8056d178b')">
          <h-input v-model="searchData.boardCode" clearable></h-input>
        </h-search>


        <h-search :title="h_i18n('90c833ebb27666eec2866dca21acf440')">
          <h-select
            v-model="searchData.colorStatus"
            :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
            style="width: 196px"
            clearable
            filterable
          >
            <h-option key="1" :label="h_i18n('49799437d0c3f01c43417ac0678d1fec')" value="1"></h-option>
            <h-option key="2" :label="h_i18n('ecfe75ea4845f1c06361dc9b3fbde68c')" value="2"></h-option>
            <h-option key="3" :label="h_i18n('dbf36ddc55bcb108170d85f41460b6df')" value="3"></h-option>
            <h-option key="4" :label="h_i18n('b4554f4c35f54f309c93f9e86abfb795')" value="4"></h-option>
            <h-option key="5" :label="h_i18n('e99db0ba053341a10f0d62b2b6bc5429')" value="5"></h-option>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('254f6b8686babf31e48ebb1894981062')" v-if="formLabel.includes(h_i18n('254f6b8686babf31e48ebb1894981062'))">
          <h-select
            v-model="searchData.industrialLine"
            clearable
            filterable
            @change="changeNull(searchData.productLine, 'productLine')"
          >
            <template
              v-for="item in data.productLinesList"
              :key="item.departmentId"
            >
              <h-option
                :label="item.departmentName"
                :value="item.departmentId"
              ></h-option>
            </template>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('6b7c4972f892c19a43a4058a4b9186e6')">
          <h-select v-model="searchData.active" clearable filterable @change="changeNull(searchData.active, 'active')">
            <h-option key="1" :label="h_i18n('c6cc397661432878e10a24834460da0d')" value="1"></h-option>
            <h-option key="0" :label="h_i18n('1abbb1748ef98f00486f7801a290fdb4')" value="0"></h-option>
            <h-option key="2" :label="h_i18n('584cd19544947c964861b3f47bf28b75')" value="2"></h-option>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('9ea126e07cdd3d8604b448edc2b1443b')">
          <h-date-picker @change="TimeChange(searchData.issueDate, {start:'issuseDateStart',end:'issuseDateEnd'})" v-model="searchData.issueDate"
                         type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>

        <template #operate>
          <h-button
            type="primary"
            :loading="data.tableLoading"
            @click="getInfo(true)"
          >
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <h-table-card :title="h_i18n('4220ba67f8bfc25dfbd64b838494b751')" :is-left="0" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <h-button-group>
          <!-- <h-button
            :loading="loadingEvent(item.code)"
            type="primary"
            @click="btnFunOfBtn(item.code)"
            :newEx="item.code == data.exportBtnCodeOfHac ? true : false"
          >
            <template #icon>
              <i
                v-if="item.code == data.exportBtnCodeOfHac"
                class="iconfont icon-daochu"
              ></i>
              <i
                v-else-if="item.code == 'S01053_HMQM_XCSH_GYSXCSH_SCN'"
                class="iconfont icon-shanchu"
              ></i>
              <i
                v-else-if="item.code == 'S01053_HMQM_XCSH_GYSXCSH_TJN'"
                class="iconfont icon-tianjia"
              ></i>
              <i
                v-else-if="item.code == 'S01053_HMQM_XCSH_GYSXCSH_XGN'"
                class="iconfont icon-zhenggai"
              ></i>
            </template>
            {{ item.name }}
          </h-button> -->
          <template v-for="item in data.btnListOfSqm" :key="item.code">
            <template v-if="item.code == 'mkhl_sbglpt_sbgl_insert'">
              <h-button :loading="data.exportLoading" type="primary" @click="goApply">
                <add-four theme="outline" />{{ h_i18n('d40c226a15eda9a1f7f2bd7011f18ecb') }}</h-button>
            </template>
            <template v-if="item.code == 'mkhl_sbglpt_sbgl_update1'">
              <h-button :loading="data.exportLoading" type="primary" @click="goReceipt">
                <receive theme="outline" />{{ h_i18n('2ffee3b7e46ad5d73d0783bfde483227') }}</h-button>
            </template>
            <template v-if="item.code == 'mkhl_sbglpt_sbgl_update2'">
              <h-button :loading="data.exportLoading" type="primary" @click="goScrap">
                <delete-themes theme="outline" />{{ h_i18n('abbb1db48d3e18cea362b23690499658') }}</h-button>
            </template>
            <template v-if="item.code == 'mkhl_sbglpt_sbgl_export'">
              <h-button :loading="data.exportLoading" type="primary" @click="excleBtn">
                <i class="iconfont icon-daochu"></i>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
            </template>
          </template>



        </h-button-group>
      </template>
      <el-table
        :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')"
        v-loading="data.tableLoading"
        height="540"
        @selection-change="listCheckBoxChange"
        border
        :data="data.dataOfTable"
        size="small"
        style="width: 100%; min-height: 540px"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="colorStatus" :label="h_i18n('90c833ebb27666eec2866dca21acf440')" width="80">
          <template #default="{ row }">
            <span v-if="row.colorStatus == '1'">{{ h_i18n('49799437d0c3f01c43417ac0678d1fec') }}</span>
            <span v-else-if="row.colorStatus == '2'">{{ h_i18n('ecfe75ea4845f1c06361dc9b3fbde68c') }}</span>
            <span v-else-if="row.colorStatus == '3'">{{ h_i18n('dbf36ddc55bcb108170d85f41460b6df') }}</span>
            <span v-else-if="row.colorStatus == '4'">{{ h_i18n('b4554f4c35f54f309c93f9e86abfb795') }}</span>
            <span v-else-if="row.colorStatus == '5'">{{ h_i18n('e99db0ba053341a10f0d62b2b6bc5429') }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="colorBoardNo" :label="h_i18n('f3737dbfae61193590bd513df85ff250')" width="200"></el-table-column>
        <el-table-column
          prop="vCode"
          :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')"
          width="90"
        ></el-table-column>
        <el-table-column
          prop="supplyName"
          :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')"
          width="200"
          class-name="textalignleft_style"
        ></el-table-column>
        <el-table-column
          prop="industrialLineName"
          :label="h_i18n('254f6b8686babf31e48ebb1894981062')"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="factory"
          :label="h_i18n('d0212de6bbcc6feb9cbb17f237bd3fd7')"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="colorCode"
          :label="h_i18n('7aadc5f1d43c0f7bf804117d00caa683')"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="colorName"
          :label="h_i18n('c1c6a5c94dcc1378b9a7a220aafa279b')"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="colorBarCode"
          :label="h_i18n('ed01f4d3ed8a3a178a537ded22268dac')"
          width="100"
        ></el-table-column>

        <el-table-column
          prop="boardCode"
          :label="h_i18n('030f1b54354b7aa3f52055b8056d178b')"
          width="100"
        ></el-table-column>

        <el-table-column prop="processMaterial" :label="h_i18n('09c9767d060689c39c9ad5b200cba1bf')" width="100"></el-table-column>
        <el-table-column prop="effect" :label="h_i18n('7e8b2fa2745e37dfe2e609baf04e319f')" width="80"></el-table-column>

        <el-table-column
          prop="dateUntil"
          :label="h_i18n('6460f46b3607ac4b78225902f085048d')"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="active"
          :label="h_i18n('6b7c4972f892c19a43a4058a4b9186e6')"
          width="80"
        >
          <template #default="{ row }">
            <span v-if="row.active == '1'">{{ h_i18n('c6cc397661432878e10a24834460da0d') }}</span>
            <span v-else-if="row.active == '0'">{{ h_i18n('1abbb1748ef98f00486f7801a290fdb4') }}</span>
            <span v-else-if="row.active == '2'">{{ h_i18n('584cd19544947c964861b3f47bf28b75') }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
        prop="issueName"
        label="下发人"
        width="180"
        ></el-table-column> -->
        <el-table-column
          prop="issueDate"
          :label="h_i18n('9ea126e07cdd3d8604b448edc2b1443b')"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="receiverName"
          :label="h_i18n('8805bb834ee3b39bcb0539817bae3321')"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="receiverAt"
          :label="h_i18n('2ade78d0370481a43986f603d8f91eda')"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="scrapDate"
          :label="h_i18n('2e2110c79765b9b43e1d192c698c4407')"
          width="120"
        >
          <template #default="{ row }">
            <span>{{ time(row.scrapDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createAt"
          :label="h_i18n('eca37cb0726c51702f70c486c1c38cf3')"
          width="170"
        ></el-table-column>
        <!-- <el-table-column
          prop="remarks"
          label="备注"
          width="200"
        ></el-table-column> -->
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getInfo"
        v-model:currentPage="searchData.pageNo"
        :page-size="10"
        layout="total, prev, pager, next,jumper"
        :total="data.total"
      >
      </el-pagination>
    </h-table-card>

    <h-dialog
      :title="h_i18n('3368a719c5560df4cba4c845ccea4236')"
      class="dialog_style"
      :width="'790px'"
      :show="state._apply"
      @close="handleClose"
      footer
    >
      <!-- <h-area title-width="90px" :all-span="12"> -->
      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tip.vCode" :content="h_i18n('c7200b626706bae909a4ee7c31ab9785')">
              <div></div>
            </el-tooltip>
            <el-autocomplete
              disabled
              class="w100"
              popper-class="planHidden"
              v-model="state.form.vCode"
              :fetch-suggestions="supplyCodeChangeCopy"
              :trigger-on-focus="false"
              @input="
                () =>
                  state.form.vCode.length < 2
                    ? (plan.showSupplyPlanCopy = false)
                    : ''
              "
              @clear="plan.showSupplyPlanCopy = false"
              clearable
              :placeholder="h_i18n('2324a40ba7ca6de7c411b8d8aefd6564')"
              @blur="detailBlur('showSupplyPlanCopy')"
              @focus="detailFocusCopy('showSupplyPlanCopy')"
            >
            </el-autocomplete>
            <h-detail width="400px" top="34px" left="0">
              <el-table
                v-show="plan.showSupplyPlanCopy"
                v-loading="data.supplyLoading"
                :data="data.supplyCodeList"
                border
                size="small"
                max-height="252"
                @row-click="clickSupplierCodeCopy"
                @mousedown="plan.planBlur = true"
              >
                <el-table-column
                  prop="supplyCode"
                  :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="supplyName"
                  :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')"
                ></el-table-column>
              </el-table>
              <div
                v-if="plan.showSupplyPlanCopy && plan.SupplyOver600"
                style="
                  color: red;
                  height: 20px;
                  background-color: #fff;
                  padding-top: 3px;
                "
              >
                <span style="padding-left: 10px; font-size: 12px"
                >{{ h_i18n('3097a85ddf1068b704c745c7b899ba7b') }}</span>
              </div>
            </h-detail>
          </h-top-label>
        </h-col>

        <h-col :span="12">
          <h-top-label :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" required >
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tip.supplyName" :content="h_i18n('de8c2a4b733c4772365f3a78173cfc13')">
              <div></div>
            </el-tooltip>
            <el-input
              disabled
              style="width: 100%"
              v-model="state.form.supplyName"
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
            ></el-input>
          </h-top-label>
        </h-col>
      </h-row>

      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('254f6b8686babf31e48ebb1894981062')" required >
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tip.industrialLine" :content="h_i18n('25725dbcd90508208c28553c252b5ff4')">
              <div></div>
            </el-tooltip>
            <el-select
              style="width: 100%"
              v-model="state.form.industrialLine"
              filterable
              clearable
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
              @change="industrialLineChange"
            >
              <el-option
                v-for="item in data.productLinesList"
                :key="item.departmentId"
                :label="item.departmentName"
                :value="item.departmentId"
              >
              </el-option>
            </el-select>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('d0212de6bbcc6feb9cbb17f237bd3fd7')" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tip.factory" :content="h_i18n('e46f3e06775c81f9fea7e4a1141386eb')">
              <div></div>
            </el-tooltip>
            <el-input
              style="width: 100%"
              v-model="state.form.factory"
              maxlength="100"
            ></el-input>
          </h-top-label>
        </h-col>

      </h-row>

      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('7aadc5f1d43c0f7bf804117d00caa683')" required >
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tip.colorCode" :content="h_i18n('41faedb4a0f21d5979bf324934b516ed')">
              <div></div>
            </el-tooltip>
            <el-select
              style="width: 100%"
              v-model="state.form.colorCode"
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
              clearable
              filterable
              @change="cCBtn"
            >
              <el-option v-for="item in data.colorList" :key="item.colorCode" :label="item.colorCode + ' - ' + item.colorName" :value="item.colorCode"></el-option>
            </el-select>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('7e8b2fa2745e37dfe2e609baf04e319f')" required >
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tip.effect" :content="h_i18n('78a93e209094785b2e922a22be59eb05')">
              <div></div>
            </el-tooltip>
            <el-select
              style="width: 100%"
              v-model="state.form.effect" filterable
              clearable
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
            >
              <el-option value="高光" :label="h_i18n('57b026b745aca7d1c4d4e38b42dc5135')"></el-option>
              <el-option value="哑光" :label="h_i18n('30cd5626e5d4d8f6b90d5fd769223178')"></el-option>
              <el-option value="半透" :label="h_i18n('18977e01daf3abfd3f1b21b84275dcca')"></el-option>
            </el-select>
          </h-top-label>
        </h-col>
      </h-row>

      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('09c9767d060689c39c9ad5b200cba1bf')" required >
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tip.processMaterial" :content="h_i18n('af05b53f23179f959477a00e3aad41d0')">
              <div></div>
            </el-tooltip>
            <el-select
              style="width: 100%"
              v-model="state.form.processMaterial" filterable
              clearable
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
            >
              <el-option value="注塑" :label="h_i18n('7157933fd0b9e6531641898c9f4e4e6e')"></el-option>
              <el-option value="喷涂" :label="h_i18n('e27154d24dfa71b20c7c17456d4afa5d')"></el-option>
              <el-option value="粉末钢板" :label="h_i18n('a92b1f9121d934ea7d471e867a2ba274')"></el-option>
              <el-option value="pcm钢板" :label="h_i18n('5932236007ade967d36c9bf4ed35e237')"></el-option>
              <el-option value="ppm钢板" :label="h_i18n('d9c0aec3ac9b0798b73c3f587bfff998')"></el-option>
              <el-option value="vcm钢板" :label="h_i18n('4c7a39b5db7aa2727259bbb75ec53c73')"></el-option>
            </el-select>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('2432b57515b3627faddccb1dd1df206e')" >
            <el-input
              style="width: 100%"
              maxlength="200"
              v-model="state.form.remarks"
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
            ></el-input>
          </h-top-label>
        </h-col>
      </h-row>
      <template #footer>
        <h-button-group align="center">
          <h-button :loading="dbqueding" type="primary" @click="saveOne">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <h-button @click="handleClose">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</h-button>
        </h-button-group>
      </template>
    </h-dialog>

    <h-dialog
      :title="state.status==h_i18n('15e9238b799e13a8bf8b7980129c38e2')?h_i18n('780daae2fea0bd2eb6285a8f28c7a9c2'):h_i18n('3be790f4bea45a69e586c13007ee55ab')"
      class="dialog_style"
      :width="'780px'"
      :show="state._confirmation"
      @close="handleClose"
      footer
    >
      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')">
            <el-input disabled v-model="state.confirmInfo.vCode"></el-input>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')">
            <el-input disabled v-model="state.confirmInfo.supplyName"></el-input>
          </h-top-label>
        </h-col>
      </h-row>

      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('254f6b8686babf31e48ebb1894981062')">
            <el-input disabled v-model="state.confirmInfo.industrialLineName"></el-input>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('d0212de6bbcc6feb9cbb17f237bd3fd7')">
            <el-input disabled v-model="state.confirmInfo.factory"></el-input>
          </h-top-label>
        </h-col>
      </h-row>

      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('7aadc5f1d43c0f7bf804117d00caa683')">
            <el-input disabled :value="state.confirmInfo.colorCode+' - '+state.confirmInfo.colorName"></el-input>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('ed01f4d3ed8a3a178a537ded22268dac')">
            <el-input disabled v-model="state.confirmInfo.colorBarCode"></el-input>
          </h-top-label>
        </h-col>
      </h-row>

      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('030f1b54354b7aa3f52055b8056d178b')">
            <el-input disabled v-model="state.confirmInfo.boardCode"></el-input>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('7e8b2fa2745e37dfe2e609baf04e319f')">
            <el-input disabled v-model="state.confirmInfo.effect"></el-input>
          </h-top-label>
        </h-col>
      </h-row>

      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('09c9767d060689c39c9ad5b200cba1bf')">
            <el-input disabled v-model="state.confirmInfo.processMaterial"></el-input>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('6460f46b3607ac4b78225902f085048d')">
            <el-input disabled v-model="state.confirmInfo.dateUntil"></el-input>
          </h-top-label>
        </h-col>
      </h-row>

      <h-row>
        <h-col :span="12">
          <h-top-label :title="h_i18n('2432b57515b3627faddccb1dd1df206e')">
            <el-input disabled v-model="state.confirmInfo.remarks"></el-input>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('9ea126e07cdd3d8604b448edc2b1443b')">
            <el-input disabled v-model="state.confirmInfo.issueDate"></el-input>
          </h-top-label>
        </h-col>
      </h-row>

      <h-row v-if="state.status==h_i18n('3ec8c93dfd3e82b28420d61e6b09e2fb')">
        <h-col :span="12">
          <h-top-label :title="h_i18n('8805bb834ee3b39bcb0539817bae3321')">
            <el-input disabled v-model="state.confirmInfo.receiverName"></el-input>
          </h-top-label>
        </h-col>
        <h-col :span="12">
          <h-top-label :title="h_i18n('2ade78d0370481a43986f603d8f91eda')">
            <el-input disabled v-model="state.confirmInfo.receiverAt"></el-input>
          </h-top-label>
        </h-col>
      </h-row>

      <!-- <form-body>
        <tr>
          <report-td title="供应商代码" colspan="6:6">{{
            state.confirmInfo?.vCode
          }}</report-td>
          <report-td title="供应商名称" colspan="6:6">{{
            state.confirmInfo?.supplyName
          }}</report-td>
        </tr>
        <tr>
          <report-td title="产业线" colspan="6:6">{{
            state.confirmInfo?.industrialLineName
          }}</report-td>
          <report-td title="供应商具体工厂" colspan="6:6">
            {{ state.confirmInfo?.factory }}
          </report-td>
        </tr>
        <tr>
          <report-td title="色板色号" colspan="6:6">
            {{ state.confirmInfo?.colorCode }}
          </report-td>
          <report-td title="色板条码" colspan="6:6">{{
            state.confirmInfo?.colorBarCode
          }}</report-td>
        </tr>
        <tr>
          <report-td title="色板编码" colspan="6:18">{{
            state.confirmInfo?.boardCode
          }}</report-td>
        </tr>

        <tr>
          <report-td title="效果" colspan="6:6">{{
            state.confirmInfo?.effect
          }}</report-td>
          <report-td title="工艺材质" colspan="6:6">{{
            state.confirmInfo?.processMaterial
          }}</report-td>
        </tr>

        <tr>
          <report-td title="有效期至" colspan="6:6">
            {{ state.confirmInfo?.dateUntil }}
          </report-td>
          <report-td title="备注" colspan="6:6">{{
            state.confirmInfo?.remarks
          }}</report-td>
        </tr>
        <tr>
          <report-td title="下发人" colspan="6:6">
            {{ state.confirmInfo?.issueName }}
          </report-td>
          <report-td title="下发日期" colspan="6:6">
            {{ state.confirmInfo?.issueDate }}
          </report-td>
        </tr>
        <tr>
          <report-td title="接收人" colspan="6:6">
            {{ state.confirmInfo?.receiverName }}
          </report-td>
          <report-td title="接收日期" colspan="6:6">
            {{ state.confirmInfo?.receiverAt }}
          </report-td>
        </tr>
      </form-body> -->

      <template #footer>
        <h-button-group align="center">
          <h-button :loading="false" type="primary" @click="updateColorBoard()"
          >{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <h-button @click="handleClose">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</h-button>
        </h-button-group>
      </template>
    </h-dialog>
  </h-list-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from "moment";
import { reactive, getCurrentInstance, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import prefix from "./test";

const { proxy, ctx } = getCurrentInstance();
const route = useRoute();

const state = reactive({
  _confirmation: false,
  confirmInfo: {},
  _apply: false,
  form: {
    vCode: "",
    supplyName: "",
    industrialLine: "",
    industrialLineName: "",
    factory: "",
    colorCode: "",
    boardCode: "",
    dateUntil: "",
    remarks: "",
    effect:"",
    processMaterial:"",
  },
  rowArr: [],
  status: "",
});
const tip = reactive({
  vCode : false,
  supplyName:false,
  industrialLine:false,
  factory:false,
  colorCode:false,
  effect:false,
  processMaterial:false,
})
const updateColorBoard = () => {
  proxy
    .$http({
      method: "POST",
      url: `${prefix}/colorBoardManagement/updateColorBoard`,
      data: {
        userCode: route.query.supplyCode,
        userName: route.query.supplyName,
        id: state.rowArr[0].id,
        industrialLineName:state.rowArr[0].industrialLineName || state.confirmInfo.industrialLineName,
        // status: state.status || "接收" || "报废",
        colorStatus: state.status == h_i18n('15e9238b799e13a8bf8b7980129c38e2') ? '4' : '5'
      },
    })
    .then((res) => {
      if (res.data.code == 200) {
        proxy.success({
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          message: h_i18n('5fac7568429909fd6f036af4edf5b956')+ state.status +h_i18n('330363dfc524cff2488f2ebde0500896'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        });
        selectPage();
        handleClose();
      } else {
        proxy.success({
          title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770'),
          message: res.data.msg,
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        });
        selectPage();
        handleClose();
      }
    });
};

const getOneById = () => {
  proxy
    .$http({
      method: "GET",
      // url: `${prefix}/colorBoardManagementPlatform/getOneById?id=${state.rowArr[0].id}`,
      url: `${prefix}/colorBoardManagement/getOneById?id=${state.rowArr[0].id}`,
      headers: { "content-type": "application/json" },
      data: {},
    })
    .then((res) => {
      state.confirmInfo = res.data.data;
    });
};

const handleClose = () => {
  const form = {
    vCode: state.form.vCode,
    supplyName: state.form.supplyName,
    industrialLine: "",
    industrialLineName: "",
    factory: "",
    colorCode: "",
    boardCode: "",
    dateUntil: "",
    remarks: "",
  }
  state.form = form;
  state._apply = false;
  state._confirmation = false;
};

const saveOne = () => {
  // if(!state.form.vCode){
  //   proxy.success({
  //     title: "提示",
  //     message: '供应商信息不能为空',
  //     confirmButtonText: "确定",
  //   });
  //   return false;
  // }
  if(!state.form.vCode){
    tip.vCode = true
    setTimeout(() => {
      tip.vCode = false
    }, 2000);
    return
  }
  if(!state.form.supplyName){
    tip.supplyName = true
    setTimeout(() => {
      tip.supplyName = false
    }, 2000);
    return
  }
  // if(!state.form.industrialLine){
  //   proxy.success({
  //     title: "提示",
  //     message: '产业线不能为空',
  //     confirmButtonText: "确定",
  //   });
  //   return false;
  // }
  if(!state.form.industrialLine){
    tip.industrialLine = true
    setTimeout(() => {
      tip.industrialLine = false
    }, 2000);
    return
  }
  // if(!state.form.factory){
  //   proxy.success({
  //     title: "提示",
  //     message: '供应商具体工厂不能为空',
  //     confirmButtonText: "确定",
  //   });
  //   return false;
  // }
  if(!state.form.factory){
    tip.factory = true
    setTimeout(() => {
      tip.factory = false
    }, 2000);
    return
  }
  // if(!state.form.colorCode){
  //   proxy.success({
  //     title: "提示",
  //     message: '色板色号不能为空',
  //     confirmButtonText: "确定",
  //   });
  //   return false;
  // }
  if(!state.form.colorCode){
    tip.colorCode = true
    setTimeout(() => {
      tip.colorCode = false
    }, 2000);
    return
  }
  // if(!state.form.effect){
  //     proxy.warning({
  //       title: "提示",
  //       message: '效果不能为空',
  //       confirmButtonText: "确定",
  //     });
  //     return;
  //   }
  if(!state.form.effect){
    tip.effect = true
    setTimeout(() => {
      tip.effect = false
    }, 2000);
    return
  }
  // if(!state.form.processMaterial){
  //   proxy.warning({
  //     title: "提示",
  //     message: '工艺材质不能为空',
  //     confirmButtonText: "确定",
  //   });
  //   return;
  // }
  if(!state.form.processMaterial){
    tip.processMaterial = true
    setTimeout(() => {
      tip.processMaterial = false
    }, 2000);
    return
  }
  proxy
    .$http({
      method: "POST",
      url: `${prefix}/colorBoardManagement/saveOne?sqmFlag=1`,
      data: {
        ...state.form,
        colorStatus: 2,
        userCode: proxy.$route.query.supplyCode,
        userName: proxy.$route.query.supplyName,
      },
    })
    .then((res) => {
      if (res.data.code == 200) {
        proxy.success({
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          message: h_i18n('adc28732e2e34e27a7d5316cd256ad3f'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        });
        selectPage();
        handleClose();
      } else {
        proxy.warning({
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          message: res.data.msg,
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        });
      }
    })
    .catch((err) => {
      proxy.error({
        title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
        message: err,
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      });
    });
};

const industrialLineChange = (feed) => {
  let temp = data.productLinesList.find((i) => i.departmentId == feed);
  state.form.industrialLineName = temp.departmentName;
};

const goReform = () => {
  if (state.form.suppySceneMutualId) {
    state._reform = true;
  } else {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('1826ec85f7211ae0e2032e9663285608'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
  }
};

const goDelete = () => {
  if (!state.form.suppySceneMutualId) {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('1826ec85f7211ae0e2032e9663285608'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  proxy
    .$http({
      method: "POST",
      url: `${prefix}/supplySceneMutual/deleteBatchByIds`,
      headers: { "content-type": "application/json" },
      data: [state.rowArr[0].id],
    })
    .then((res) => {
      console.log(res);
      if (res.data.code === "200") {
        proxy.success({
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          message: h_i18n('0007d170de017dafc266aa03926d7f00'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: async (action) => {
            selectPage();
          },
        });
      }
    });
};

const searchData = reactive({
  supplyCode: "",
  supplyName: "",
  industrialLineName: "",
  colorStatus: "",
  // mtlNo: "",
  pageNo: 1,
  pageSize: 10,
});

const formLabel = [
  h_i18n('1b7ecd2bdbd8a1a112dead57724f06df'),
  h_i18n('9190cc22c9ba377113bc54ac51013a0b'),
  h_i18n('c0c9a6a00434a0ae3245d4c4c0883d78'),
  h_i18n('eb13449afff17eb45c5eedb8f7ca244c'),
  h_i18n('03490f3868798323211aa633194df2c1'),
  h_i18n('254f6b8686babf31e48ebb1894981062'),
];

//列表表头列表
const columns = [
  h_i18n('eb13449afff17eb45c5eedb8f7ca244c'),
  h_i18n('89bdb58413b5a7e110f08677cc7c4120'),
  h_i18n('84f9624fee4357e396b8d57707ea748d'),
  h_i18n('79101b9a4632dcc59011cbfd47f4bbcc'),
  h_i18n('03490f3868798323211aa633194df2c1'),
  h_i18n('c0c9a6a00434a0ae3245d4c4c0883d78'),
  h_i18n('ab0c72ccb95d779c819b12c3ca664771'),
  h_i18n('1b7ecd2bdbd8a1a112dead57724f06df'),
  h_i18n('9190cc22c9ba377113bc54ac51013a0b'),
  h_i18n('826a75295b1dcce76c0abbb307fbe5ae'),
  h_i18n('cfbd2a5c120ca3f0a7cbdefb09058b7f'),
  h_i18n('641312eacaf235c657d229acef28a645'),
  h_i18n('f83e611ab76638e2cfb5b08ebb8114e7'),
  h_i18n('04f1cccbaffacee448a3e538de2ffd9a'),
  h_i18n('cc3704d034a8efd9ae87db54f7158089'),
  h_i18n('95e0d70d1809d5267c2419eda58e78ca'),
  h_i18n('037e59949571287348f183cf6c798925'),
  h_i18n('ae27d6f465386eb63210704c8918c6c4'),
  h_i18n('0039880117c13787732d259f5bc9f7f5'),
  h_i18n('b30fcfc3cf21fc7b4b92368972188372'),
  h_i18n('25da3f9a4ea6e6dd1f292f5d6886b854'),
  h_i18n('38cc93580f9e8cebf327ea7bb4e4dbbd'),
  h_i18n('6a49cf9f5c7670b5a173ed3a8a9f67cf'),
];

const data = reactive({
  exportBtnCodeOfHac: "S01053_HMQM_ZLGS_GYSSTQ_SCSJ_DC", //导出
  dataOfTable: [],
  instigation: [
    {
      valueId: 2117,
      valueTypeId: null,
      valueTypeName: null,
      valueName: h_i18n('2b3c6ed1d8840afd3da2b28719d75b14'),
      reamrk: null,
      deleteStatus: null,
    },
    {
      valueId: 2118,
      valueTypeId: null,
      valueTypeName: null,
      valueName: h_i18n('b96b16287a4ded136be309ed682aed52'),
      reamrk: null,
      deleteStatus: null,
    },
    {
      valueId: 2119,
      valueTypeId: null,
      valueTypeName: null,
      valueName: h_i18n('f750ffd19492f47477a51951775d4ac4'),
      reamrk: null,
      deleteStatus: null,
    },
  ],
  sybAllList: [], //工厂小微
  // microenterprise: [],
  categoryList: [], // 大类
  supply: [],
  productLinesList: [], // 产业线
  supplyCodeList: [],
  mtlNoList: [],
  name: "",
  nickName: "",
  buttonList: [],
  total: 0,
  mtlLoading: false,
  supplyLoading: false,
  tableLoading: false,
  exportLoading: false,
  picDialog: false,
  url: "",
  btnCodeList:[
    "mkhl_sbglpt_sbgl_insert","mkhl_sbglpt_sbgl_update1","mkhl_sbglpt_sbgl_update2","mkhl_sbglpt_sbgl_export"
  ],
  btnListOfSqm:[]
});
// 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
    case "mkhl_sbglpt_sbgl_insert":
      break;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
    case "mkhl_sbglpt_sbgl_insert":
      return
  }
}
const searchTemp = reactive({});

// const getSybList = () => {
//   proxy
//     .$http({
//       method: "get",
//       url: "/unload/baseCommon/listSybInfoByName",
//       headers: { "content-type": "application/json" },
//       params: {
//         name: proxy.$route.query.name,
//       },
//     })
//     .then((res) => {
//       data.microenterprise = res.data;
//     });
// };
// 色板色号 change
const cCBtn = (v)=>{
  state.form.colorName = data.colorList.filter(item=>{
    return item.colorCode == v
  })[0]?.colorName
  console.group()
  console.log(state.form.colorCode)
  console.log(state.form.colorName)
  console.groupEnd()
}
// 查询色板色号
const getColorCode =() => {
  proxy.$http({
    url: '/base/color/getPageList',
    method: "post",
    data: {
      pageSize:2000,
      pageIndex:1,
    }
  }).then(res=>{
    console.log(res.data.data)
    if(res.data.data?.length > 0){
      data.colorList = res.data.data
    }
  }).catch(err=>{
  }).finally(()=>{
  })
}
const getBaseValues = () => {
  proxy
    .$http({
      method: "GET",
      // url: `/supplier/comboxData/getBaseValues?valueTypeId=102`,
      url: "/base/basicData/listBaseValues?valueTypeId=102",
      headers: { "content-type": "application/json" },
      data: {},
    })
    .then((res) => {
      console.log(res);
      data.instigation = res.data.data;
      // debugger
    });
};

const getMaterielCategories = () => {
  proxy
    .$http({
      method: "GET",
      url: `${prefix}/basicData/getMaterielCategories`,
      // url: "/base/basicData/getMaterielCategories",
      // url: "/supplier/comboxData/getMaterielCategories",
      headers: { "content-type": "application/json" },
      data: {},
    })
    .then((res) => {
      console.log(res);
      data.supply = res.data.data;
      // debugger
    });
};

// 时间范围选择
const TimeChange = (date, {start,end}) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
}

const selectPage = () => {
  proxy
    .$http({
      method: "POST",
      url: `${prefix}/colorBoardManagement/selectPage`,
      // url: `${prefix}/supplySceneMutual/selectPage`,

      headers: { "content-type": "application/json" },
      data: {
        ...searchData,
        vCode: route.query.supplyCode,
        fixConfig: true,
        issueDate:undefined,
        queryFlag:'sqm',
        // "beginDateOne": "string",
        // "endDateOne": "string",
        // "beginDateTwo": "string",
        // "endDateTwo": "string",
        // "beginDateThird": "string",
        // "endDate1Third": "string",
        // "beginDateFourth": "string",
        // "endDate1Fourth": "string",
        // "pageNo": 0,
        // "pageSize": 0,
        // "syb": 0,
        // "queryFlag": "string",
        // "userCode": "string",
        // "userName": "string",
        // "supplyCode": "string",
        // "supplyName": "string",
        // "materieltypeId": "string",
        // "initiateType": 0,
        // "sybId": 0
      },
    })
    .then((res) => {
      if (
        res.data.code == "200" &&
        res.data.msg == "成功" &&
        res.data.success == true
      ) {
        data.dataOfTable = res.data.data.records;

        data.total = res.data.data.total;
        data.tableLoading = false;
      } else {
        proxy.warning({
          message: res.data.msg,
          title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        });
        data.tableLoading = false;
      }
    })
    .catch((err) => {
      proxy.warning({
        message: err,
        title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770'),
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      });
      data.tableLoading = false;
    });
};

onMounted(() => {
  // getSybList();
  if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }else{
    data.btnListOfSqm = [{code:"mkhl_sbglpt_sbgl_insert",name:h_i18n('d40c226a15eda9a1f7f2bd7011f18ecb')},{code:"mkhl_sbglpt_sbgl_update1",name:h_i18n('2ffee3b7e46ad5d73d0783bfde483227')},{code:"mkhl_sbglpt_sbgl_update2",name:h_i18n('abbb1db48d3e18cea362b23690499658')},{code:"mkhl_sbglpt_sbgl_export",name:h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95')}]
  }
  getBaseValues();
  getMaterielCategories();
});

/**
 * 传高度
 */
const changeMethod = () => {
  proxy.postThisPageHeight();
};
/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
const listCheckBoxChange = (rowArr) => {
  console.log("rowArr", rowArr);
  state.rowArr = rowArr;
  state.form.suppySceneMutualId = rowArr[0]?.id || "";
};

// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined;
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
};
const http = reactive({
  mtlSearchHttp: false,
  supplySearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
  showSupplyPlan: false,
  showSupplyPlanCopy: false,
  MtlOver600: false,
  SupplyOver600: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showSupplyPlan") {
    if (searchData.supplyCode.length >= 2) {
      plan[v] = true;
    }
  } else if (v == "showMtlPlan") {
    if (searchData.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};

// 弹窗聚焦
const detailFocusCopy = (v) => {
  plan.planBlur = false;
  if (v == "showSupplyPlanCopy") {
    if (state.form.vCode.length >= 2) {
      plan[v] = true;
    }
  } else if (v == "showMtlPlan") {
    if (state.form.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.mtlNo = row.mtlNo;
  plan.showMtlPlan = false;
};
const clickSupplierCode = (row) => {
  searchData.supplyCode = row.supplyCode;
  plan.showSupplyPlan = false;
};
const clickSupplierCodeCopy = (row) => {
  state.form.vCode = row.supplyCode;
  state.form.supplyName = row.supplyName;
  plan.showSupplyPlanCopy = false;
};
/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.mtlNo.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    proxy
      .$http({
        method: "POST",
        url: "/base/basicData/searchMaterielList",
        headers: { "content-type": "application/json" },
        data: {
          mtlNo: searchData.mtlNo,
        },
        cancelToken: http.mtlSearchHttp.token,
      })
      .then((res) => {
        data.mtlNoList = res.data.data;
        if (data.mtlNoList.length >= 600) {
          plan.MtlOver600 = true;
          data.mtlLoading = false;
        } else {
          plan.MtlOver600 = false;
          data.mtlLoading = false;
        }
      })
      .catch((e) => {});
  }
};
/**
 * 供应商模糊查询
 */
const supplyCodeChange = () => {
  plan.planBlur = false;
  if (http.supplySearchHttp) http.supplySearchHttp.cancel();
  http.supplySearchHttp = axios.CancelToken.source();
  if (searchData.supplyCode.length < 2) {
    plan.showSupplyPlan = false;
  } else {
    plan.showSupplyPlan = true;
    data.supplyLoading = true;
    proxy
      .$http({
        method: "post",
        url: "/base/basicData/searchSupplierList",
        headers: { "content-type": "application/json" },
        data: {
          supplyCode: searchData.supplyCode,
        },
        cancelToken: http.supplySearchHttp.token,
      })
      .then((res) => {
        data.supplyCodeList = res.data.data;
        if (data.supplyCodeList.length >= 600) {
          plan.SupplyOver600 = true;
          data.supplyLoading = false;
        } else {
          plan.SupplyOver600 = false;
          data.supplyLoading = false;
        }
      })
      .catch((e) => {});
  }
};

/**
 * 供应商模糊查询
 */
const supplyCodeChangeCopy = () => {
  plan.planBlur = false;
  if (http.supplySearchHttp) http.supplySearchHttp.cancel();
  http.supplySearchHttp = axios.CancelToken.source();
  if (state.form.vCode.length < 2) {
    plan.showSupplyPlanCopy = false;
  } else {
    plan.showSupplyPlanCopy = true;
    data.supplyLoading = true;
    proxy
      .$http({
        method: "post",
        url: "/base/basicData/searchSupplierList",
        headers: { "content-type": "application/json" },
        data: {
          supplyCode: state.form.vCode,
        },
        cancelToken: http.supplySearchHttp.token,
      })
      .then((res) => {
        data.supplyCodeList = res.data.data;
        if (data.supplyCodeList.length >= 600) {
          plan.SupplyOver600 = true;
          data.supplyLoading = false;
        } else {
          plan.SupplyOver600 = false;
          data.supplyLoading = false;
        }
      })
      .catch((e) => {});
  }
};

// 产业线查询
const productLines = () => {
  return proxy
    .$http({
      method: "get",
      url: `${prefix}/colorBoardManagementPlatform/selectPLInfoListForSQM`,
      // url: "/unload/testEquipment/listPlInfoByName",
      dataType: "application/json",
      params: {
        name: route.query.supplyCode,
        nickName: route.query.supplyName,
      },
    })
    .then((res) => {
      console.log(res);
      if (res.status === 200) {
        data.productLinesList = res.data.data;
      }
    })
    .catch((err) =>
      proxy.error(
        h_i18n('52dc3a1c87479531fb9e09d933025f34') +
        this.errorDispose(err.response.data || err.response || err)
      )
    );
};

// loading事件
const loadingEvent = (code) => {
  switch (code) {
    case data.exportBtnCodeOfHac:
      return data.exportLoading;

    default:
      return null;
  }
};
// btn事件
const btnFunOfBtn = (code) => {
  switch (code) {
    case "新增申请":
      goApply();
      break;
    case "确认报废":
      goScrap();
      break;
    case "确认接收":
      goReceipt();
      break;
    case data.exportBtnCodeOfHac:
      excleBtn();
      break;
    default:
      return null;
  }
};

// 查询 emr/listPage
const getInfo = (flag) => {
  if (true == flag) {
    searchData.pageNo = 1;
  }
  data.tableLoading = true;
  selectPage();
};
// 导出 emr/export
const excleBtn = () => {
  if (data.total > 5000) {
    proxy.warning({
      message: h_i18n('5d11f64ddbaa899949fcdecee0185f2d'),
      title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: (action) => {},
    });
    return;
  }
  if (data.total < 1) {
    proxy.warning({
      message: h_i18n('f59ec2b6c282f2c37663f524c2a318c3'),
      title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: (action) => {},
    });
    return;
  }
  data.exportLoading = true;
  proxy.startLoading(h_i18n('c481667043aa50a5be49cca9959f17a9'));
  proxy.httpFile(
    {
      method: "post",
      url: "/base/colorBoardManagement/exportSQMPage",
      data: {
        ...searchData,
        vCode: route.query.supplyCode,
        fixConfig: true,
        issueDate:undefined,
        pageNo: undefined,
        pageSize: undefined,
        queryFlag:'sqm',
      },
    },
    h_i18n('054dbda22caaf9a89dc7949c16ec653c')
  ).then(res=>{
    data.exportLoading = false;
  }).catch(err=>{
    data.exportLoading = false;
    proxy.closeLoading()
  })
};

const goApply = () => {
  state._apply = true;
};

const goScrap = () => {
  if (state.rowArr.length > 1) {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('1aa503920b05f6cf408787703881d200'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  if (state.rowArr.length == 0) {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('3961247a969c40c139238cff7d4a49c4'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  // 报废状态不可重复报废，其他状态都可以报废
  // if(state.rowArr[0].status == '报废'){
  //   proxy.warning({
  //     title: "提示",
  //     message: '报废状态不可重复报废',
  //     confirmButtonText: "确定",
  //   });
  //   return;
  // }
  if (state.rowArr[0].active == "0") {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('2433fb3fde2c313d54671a448716e3f9'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  if (state.rowArr[0].active == "2") {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('188dfe15e32d44493fe3731df8b7a231'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  // 只有状态是已下发并且接收人不为空的时候可以报废，其他时都不能报废
  // 只有“已接收&有效”的才可以点击，否则给出提示// 1. 接收后状态更新为“已报废”，色板状态“无效”
  // if(state.rowArr[0].colorStatusName == '已下发' && (state.rowArr[0].receiverName != '' && state.rowArr[0].receiverName != null) ){
  if(state.rowArr[0].colorStatus == '4' && state.rowArr[0].active == '1' ){
    // console.log(state.rowArr[0],'state.rowArr[0]state.rowArr[0]state.rowArr[0]')
  } else {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('fa63f065ecbd5a060d847e71544284c9'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  state._confirmation = true;
  state.status = h_i18n('3ec8c93dfd3e82b28420d61e6b09e2fb');
  getOneById();
};

const goReceipt = () => {
  if (state.rowArr.length > 1) {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('117f1507d7ad6b8a9cd942667b93310b'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  if (state.rowArr.length == 0) {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('3961247a969c40c139238cff7d4a49c4'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }

  // if(state.rowArr[0].status == '过期'){
  //   proxy.warning({
  //     title: "提示",
  //     message: '该色板已经过期，不可接收',
  //     confirmButtonText: "确定",
  //   });
  //   return;
  // }
  // if(state.rowArr[0].status == '报废'){
  //   proxy.warning({
  //     title: "提示",
  //     message: '该色板已报废，不可接收',
  //     confirmButtonText: "确定",
  //   });
  //   return;
  // }

  if (state.rowArr[0].active == "0") {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('540f76be02e54dffb839bfca87ebbaa3'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  if (state.rowArr[0].active == "2") {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('100ee566ffccb988e8fb21b788043e52'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }

  // colorstatus == '已下发' && jieshouren == '' 只有状态是已下发并且接收人为空的时候可以接收，其他时都不能接收
  // 只有“已下发&有效”的才可以点击，否则给出提示 1. 接收后状态更新为“已接收”，色板状态“有效”
  // if(state.rowArr[0].colorStatusName == '已下发' && (state.rowArr[0].receiverName == null || state.rowArr[0].receiverName == '' )){
  if(state.rowArr[0].colorStatus == '1' && state.rowArr[0].active == '1'){
  } else {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('e1fc6dd1b28dd71238722f3056adb5d9'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
    return;
  }
  state._confirmation = true;
  state.status = h_i18n('15e9238b799e13a8bf8b7980129c38e2');
  getOneById();
};

const goNew = () => {
  proxy.$router.push({
    path: "/SupplierMutualNew",
    query: {
      name: proxy.$route.query.name,
      nickName: proxy.$route.query.nickName,
    },
  });
};
const goDetail = (row) => {
  if (row.id) {
    proxy.$router.push({
      path: "/SupplierMutualDetail",
      query: {
        name: proxy.$route.query.name,
        nickName: proxy.$route.query.nickName,
        id: row.id,
      },
    });
  } else {
    proxy.warning({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('1826ec85f7211ae0e2032e9663285608'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    });
  }
};

onMounted(() => {
  console.log(route.query);
  debugger
  if (route.query) {
    state.form.vCode = route.query.supplyCode;
    state.form.supplyName = route.query.supplyName;
    state.form.supplyCode = route.query.supplyCode;
  }
  if(!route.query.supplyCode){
    proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: (action) => {
        proxy.$router.back()
      },})
    return
  }

  // if (process.env.NODE_ENV == "development") {
  //   console.log(process.env.NODE_ENV + "环境，可以显示全部按钮");

  //   data.buttonList = [
  //     { code: "新增申请", name: "新增申请" },
  //     { code: "确认接收", name: "确认接收" },
  //     { code: "确认报废", name: "确认报废" },
  //     // { code: data.exportBtnCodeOfHac, name: "导出" },
  //   ];
  // } else {
  //   proxy
  //     .searchButtonFromHacByCode(
  //       "/newproduct/NewSupplySceneMutual/NewSupplySceneMutualList",
  //       data.name,
  //       data.nickName
  //     )
  //     .then((v) => {
  //       console.log(v);
  //       // debugger
  //       data.buttonList = v;
  //     });
  // }
  getColorCode()
  productLines();
  getInfo();
});
</script>

<style lang="scss">
.badMarket_style {
  .el-table td.textalignleft_style .cell {
    text-align: left !important;
  }

  .haier-card
  .haier-card--body
  .el-table
  .el-table__body-wrapper
  .el-table__body
  tbody
  .el-table__row {
    .blue-font-style {
      padding-top: 0px;
      padding-bottom: 0px;
      .cell {
        // color: #2681ff !important;
      }
    }
  }
}

.dialog_style .haier-dialog {
  top: 100px;
  .w100 {
    .el-input.el-input--prefix.el-input--suffix{
      width: 100% !important;
    }
    input.el-input__inner{
      padding-left: 15px;
    }
  }
  .img_wrap {
    // overflow: auto;
    width: 100%;
    height: 500px;
    .el-image {
      vertical-align: text-top;
      width: 100%;
      height: 100%;
      display: inline;
      img {
        // object-fit: contain;
      }
    }
  }
}
.planHidden {
  display: none;
}
</style>